module.exports = __webpack_public_path__ + "img/cpxq1.72ebef5c.png";